import { render, staticRenderFns } from "./UpdateNotification.vue?vue&type=template&id=3127f9a4&scoped=true&"
import script from "./UpdateNotification.vue?vue&type=script&lang=js&"
export * from "./UpdateNotification.vue?vue&type=script&lang=js&"
import style0 from "./UpdateNotification.vue?vue&type=style&index=0&id=3127f9a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3127f9a4",
  null
  
)

export default component.exports